import React from 'react'
import { child_icon_2, user_add_icon, users_add_icon } from '../../../Shared/icons'
import CardSelector from '../../../Shared/CardSelector/CardSelector'
import wf_youth from '../../WizardModel/wf_youth'
import wf_adult_myself from '../../WizardModel/wf_adult_myself'
import wf_adult_someoneelse from '../../WizardModel/wf_adult_someoneelse'
import './ParticipantType.css'

const youthChoices = [
    {
        id: "MyChild",
        title: 'My Child',
        subTitle: 'My child will be participating',
        description: '',
        icon: child_icon_2
    },
];

const adultChoices = {
    registerForMyself: {
        id: "RegisterForMyself",
        title: 'Register for Myself',
        subTitle: "I will be participating",
        description: '',
        icon: user_add_icon
    },
    allReadyRegistered: {
        id: "AllReadyRegistered",
        title: 'Register for Myself',
        subTitle: "Our records indicate that you are already participating in this League",
        description: '',
        icon: user_add_icon,
        disabled: true
    },
    invalidAge: {
        id: "invalidAge",
        title: 'Register for Myself',
        subTitle: "Your age is invalid to participate, you must be 18 years of age or older",
        description: '',
        icon: user_add_icon,
        disabled: true
    },
    registerForSomeoneElse: {
        id: "RegisterForSomeoneElse",
        title: 'Register for Someone Else',
        subTitle: 'I will be registering someone else',
        description: '',
        icon: users_add_icon
    },
};

const mixedChoices = {
    registerForMyChild: {
        id: "MyChild",
        title: 'My Child',
        subTitle: "'My child will be participating",
        description: '',
        icon: child_icon_2
    },
    registerForMyself: {
        id: "RegisterForMyself",
        title: 'Register for Myself',
        subTitle: "I will be participating",
        description: '',
        icon: user_add_icon
    },
    allReadyRegistered: {
        id: "AllReadyRegistered",
        title: 'Register for Myself',
        subTitle: "Our records indicate that you are already participating in this League",
        description: '',
        icon: user_add_icon,
        disabled: true
    },
    invalidAge: {
        id: "invalidAge",
        title: 'Register for Myself',
        subTitle: "Your age is invalid to participate, you must be 18 years of age or older",
        description: '',
        icon: user_add_icon,
        disabled: true
    },
    registerForSomeoneElse: {
        id: "RegisterForSomeoneElse",
        title: 'Register for Someone Else',
        subTitle: 'I will be registering someone else',
        description: '',
        icon: users_add_icon
    },
};

function ParticipantType(props) {

    function onParticipantTypeChanged(e) {

        let selectedAction = e.target.value;

        let stepState = {
            participantType: selectedAction
        };

        switch (selectedAction) {
            case 'MyChild':
                props.setWorkflow(wf_youth);
                stepState.memberId = null;
                break;
            case 'RegisterForMyself':
                props.setWorkflow(wf_adult_myself);
                stepState.memberId = props.wizardState.applicantMemberId;
                break;
            case 'RegisterForSomeoneElse':
                props.setWorkflow(wf_adult_someoneelse);
                stepState.memberId = null;
                break;
        }

        props.updateWizardState((prev) => {
            let currentState = { ...prev };

            delete currentState.isMemberFoundBySearch;

            return {
                ...currentState,
                ...stepState
            };
        });

        props.nextView(props.wizardState);
    }

    function ParticipantTypeContent() {
        let choices = [];
        if (props.wizardState?.leagueCategory?.toLowerCase() === 'adult') {
            let adultChoicesList = [];

            if (props.wizardState?.isAlreadyRegistered === true) {
                adultChoicesList.push(adultChoices.allReadyRegistered);
            } else if (props.wizardState?.isAgeValid === false) {
                adultChoicesList.push(adultChoices.invalidAge);
            } else {
                adultChoicesList.push(adultChoices.registerForMyself);
            }

            adultChoicesList.push(adultChoices.registerForSomeoneElse);
            choices = adultChoicesList;

        } else if (props.wizardState?.leagueCategory?.toLowerCase() === 'mixed') {
            let mixedChoicesList = [];

            if (props.wizardState?.isAlreadyRegistered === true) {
                mixedChoicesList.push(mixedChoices.allReadyRegistered);
            } else if (props.wizardState?.isAgeValid === false) {
                mixedChoicesList.push(mixedChoices.invalidAge);
            } else {
                mixedChoicesList.push(mixedChoices.registerForMyself);
            }

            mixedChoicesList.push(mixedChoices.registerForMyChild);
            mixedChoicesList.push(mixedChoices.registerForSomeoneElse);
            choices = mixedChoicesList;

        } else {
            choices = youthChoices;
        }

        var payload = choices.map(choice => ({
            id: choice.id,
            title: choice.title,
            subTitle: choice.subTitle,
            description: choice.description,
            icon: choice.icon,
            checked: (props.wizardState?.participantType === choice.id),
            disabled: choice.disabled
        }));
        return <CardSelector list={payload} groupName="ParticipantType" onCardSelected={onParticipantTypeChanged} />;
    }

    return (
        <>
            <div className="row">
                <div className="col h4 wizard-step-title">
                    {props.step.title} {props.wizardState?.leagueName}
                </div>
            </div>
            <div className="row gap-2">
                {ParticipantTypeContent()}
            </div>
            <div className='wizard-buttons-container'>
                <button type="button" className="btn btn-primary bowl-btn" onClick={props.backView} disabled={true}>Back</button>
            </div>
        </>
    )
}

export default ParticipantType